import { defaultClothesConditionsOptions, getConditionsFilterConfig } from '../filters/condition';
import { getDefaultShopConfig } from './default';
import * as custom from '../filters/marketplace-custom-config';
import { getSizeFilterConfigFromOptions } from '../filters/size';
import { getBrandDirectFilterConfig } from '../filters/brandDirect';

const youerSizeOptions = [
  { key: 'XXS', label: 'XXS' },
  { key: 'XS', label: 'XS' },
  { key: 'S', label: 'S' },
  { key: 'M', label: 'M' },
  { key: 'L', label: 'L' },
  { key: 'XL', label: 'XL' },
  { key: 'XXL', label: 'XXL' },
  { key: 'O/S', label: 'O/S' },
];

export const youerShopConfig = {
  ...getDefaultShopConfig(),
  filters: [
    ...custom.filters,
    getConditionsFilterConfig({ options: defaultClothesConditionsOptions }),
    getBrandDirectFilterConfig(),
    getSizeFilterConfigFromOptions({ options: youerSizeOptions }),
  ],
};
